import {
  CurrencyType,
  MultiCurrencyFeatureUtils as CoreMultiCurrencyFeatureUtils,
} from '@okletsplay/core';
import config from 'config/config';

class MultiCurrencyFeatureUtils extends CoreMultiCurrencyFeatureUtils {
  /**
   * Calls original and if original returns `null` then returns default.
   */
  public currencyType(): CurrencyType {
    const result = super.currencyType();
    return result ? result : CurrencyType.USDT_OKLP;
  }
}

export const MultiCurrencyConfig = new MultiCurrencyFeatureUtils(
  config.multiCurrencyFeatures ?? ''
);
